import { setApiKey } from "lib/fileStackUtils";

export default function configureFileStack(filepickerApiKey) {
  setApiKey(filepickerApiKey);
}
